import { Skeleton, SkeletonProps } from '@material-ui/lab';

import { useCustomTheme } from '@/hooks/useCustomTheme';

export const CustomSkeleton = (props: Partial<SkeletonProps>) => {
  const { customBorderRadius } = useCustomTheme();

  return (
    <Skeleton
      variant="rect"
      width={'100%'}
      height={'400px'}
      {...props}
      style={{ borderRadius: customBorderRadius.paper, ...props.style }}
    />
  );
};
